/**
 * Endpoint methods related to Completions
*/

import API from "./Api";

export default {
  /**
   * Gets all the Completions related to the logged-In Instance
   */
  async getAllOwnUsersCompletions() {

    return API.get("/completions/getallown", "COOKIE_TOKEN_SESSION");
  },
};
